// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buy-credits-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 2100;
}

.buy-credits-card {
  width: min(520px, 100%);
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  animation: buyCreditsIn 0.15s ease;
}

@keyframes buyCreditsIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.buy-credits-header {
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.buy-credits-header h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.buy-credits-header p {
  margin: 0;
  color: var(--color-text-secondary);
  font-size: 13px;
  line-height: 1.45;
}

/* ── Subscription Upsell ── */
.buy-credits-upsell {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px;
  border: 1px solid color-mix(in srgb, var(--color-accent-base) 30%, var(--color-border-input));
  border-radius: 8px;
  background: color-mix(in srgb, var(--color-accent-base) 5%, var(--color-bg-canvas-surface));
}

.buy-credits-upsell__tag {
  display: inline-block;
  width: fit-content;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--color-accent-base);
  background: color-mix(in srgb, var(--color-accent-base) 12%, transparent);
  border: 1px solid color-mix(in srgb, var(--color-accent-base) 25%, transparent);
  padding: 2px 10px;
  border-radius: 20px;
}

.buy-credits-upsell__plans {
  display: flex;
  gap: 10px;
}

.buy-credits-upsell__plan {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding: 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  background: var(--color-bg-canvas-surface);
  transition: border-color 0.15s;
}

.buy-credits-upsell__plan:hover {
  border-color: color-mix(in srgb, var(--color-accent-base) 45%, var(--color-border-input));
}

.buy-credits-upsell__plan--featured {
  border-color: var(--color-accent-base);
  box-shadow: 0 0 0 1px var(--color-accent-base);
}

.buy-credits-upsell__plan-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 8px;
}

.buy-credits-upsell__plan-header strong {
  font-size: 14px;
  color: var(--color-text-primary);
}

.buy-credits-upsell__plan-header span {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-secondary);
}

.buy-credits-upsell__plan-features {
  list-style: none;
  padding: 0;
  margin: 0 0 12px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.buy-credits-upsell__plan-features li {
  font-size: 11px;
  color: var(--color-text-secondary);
  line-height: 1.4;
  padding-left: 14px;
  position: relative;
}

.buy-credits-upsell__plan-features li::before {
  content: "\\2713";
  position: absolute;
  left: 0;
  color: var(--color-accent-base);
  font-weight: 600;
  font-size: 10px;
}

.buy-credits-upsell__btn {
  width: 100%;
  padding: 7px 12px;
  border: none;
  border-radius: 6px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  text-align: center;
  background: var(--color-accent-base);
  color: #fff;
  transition: opacity 0.15s;
}

.buy-credits-upsell__btn:hover:not(:disabled) {
  opacity: 0.88;
}

.buy-credits-upsell__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.buy-credits-upsell__btn--alt {
  background: transparent;
  border: 1px solid var(--color-border-input);
  color: var(--color-text-primary);
  font-weight: 500;
}

@media (max-width: 640px) {
  .buy-credits-upsell__plans {
    flex-direction: column;
  }
}

.buy-credits-tiers {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.buy-credits-tier {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 14px 8px;
  background: var(--color-bg-input);
  border: 2px solid var(--color-border-input);
  cursor: pointer;
  font-family: inherit;
  transition: border-color 0.1s;
}

.buy-credits-tier:hover {
  border-color: var(--color-text-secondary);
}

.buy-credits-tier.selected {
  border-color: var(--color-accent-base);
  background: var(--color-bg-canvas-surface);
}

.buy-credits-tier-amount {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.buy-credits-tier-label {
  font-size: 11px;
  color: var(--color-text-secondary);
}

.buy-credits-custom {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.buy-credits-custom-label {
  font-size: 12px;
  color: var(--color-text-secondary);
  font-weight: 500;
}

.buy-credits-custom-input-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.buy-credits-custom-input-row span {
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.buy-credits-custom-input {
  flex: 1 1;
  padding: 8px 10px;
  font-family: inherit;
  font-size: 14px;
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
  color: var(--color-text-primary);
  outline: none;
}

.buy-credits-custom-input:focus {
  border-color: var(--color-accent-base);
}

.buy-credits-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 4px;
}

.buy-credits-primary,
.buy-credits-secondary {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid var(--color-border-input);
  font-family: inherit;
  font-size: 14px;
  cursor: pointer;
}

.buy-credits-primary {
  background: var(--color-accent-base);
  color: var(--color-text-on-accent);
  font-weight: 600;
}

.buy-credits-primary:hover:not(:disabled) {
  filter: brightness(0.96);
}

.buy-credits-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.buy-credits-secondary {
  background: transparent;
  color: var(--color-text-secondary);
  font-weight: 500;
}

.buy-credits-secondary:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.buy-credits-error {
  font-size: 13px;
  color: var(--color-danger, #e55);
  text-align: center;
  margin: 0;
}

@media (max-width: 640px) {
  .buy-credits-card {
    padding: 22px 16px;
  }

  .buy-credits-tiers {
    grid-template-columns: repeat(2, 1fr);
  }

  .buy-credits-header h2 {
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BuyCreditsModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,6FAA6F;EAC7F,kBAAkB;EAClB,2FAA2F;AAC7F;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;EAC/B,yEAAyE;EACzE,+EAA+E;EAC/E,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,yFAAyF;AAC3F;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,2CAA2C;EAC3C,eAAe;EACf,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,iCAAiC;EACjC,2CAA2C;EAC3C,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,oBAAoB;EACpB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".buy-credits-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  z-index: 2100;\n}\n\n.buy-credits-card {\n  width: min(520px, 100%);\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  padding: 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  animation: buyCreditsIn 0.15s ease;\n}\n\n@keyframes buyCreditsIn {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.buy-credits-header {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.buy-credits-header h2 {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.buy-credits-header p {\n  margin: 0;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n/* ── Subscription Upsell ── */\n.buy-credits-upsell {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 14px;\n  border: 1px solid color-mix(in srgb, var(--color-accent-base) 30%, var(--color-border-input));\n  border-radius: 8px;\n  background: color-mix(in srgb, var(--color-accent-base) 5%, var(--color-bg-canvas-surface));\n}\n\n.buy-credits-upsell__tag {\n  display: inline-block;\n  width: fit-content;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--color-accent-base);\n  background: color-mix(in srgb, var(--color-accent-base) 12%, transparent);\n  border: 1px solid color-mix(in srgb, var(--color-accent-base) 25%, transparent);\n  padding: 2px 10px;\n  border-radius: 20px;\n}\n\n.buy-credits-upsell__plans {\n  display: flex;\n  gap: 10px;\n}\n\n.buy-credits-upsell__plan {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  background: var(--color-bg-canvas-surface);\n  transition: border-color 0.15s;\n}\n\n.buy-credits-upsell__plan:hover {\n  border-color: color-mix(in srgb, var(--color-accent-base) 45%, var(--color-border-input));\n}\n\n.buy-credits-upsell__plan--featured {\n  border-color: var(--color-accent-base);\n  box-shadow: 0 0 0 1px var(--color-accent-base);\n}\n\n.buy-credits-upsell__plan-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  margin-bottom: 8px;\n}\n\n.buy-credits-upsell__plan-header strong {\n  font-size: 14px;\n  color: var(--color-text-primary);\n}\n\n.buy-credits-upsell__plan-header span {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n}\n\n.buy-credits-upsell__plan-features {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 12px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.buy-credits-upsell__plan-features li {\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  line-height: 1.4;\n  padding-left: 14px;\n  position: relative;\n}\n\n.buy-credits-upsell__plan-features li::before {\n  content: \"\\2713\";\n  position: absolute;\n  left: 0;\n  color: var(--color-accent-base);\n  font-weight: 600;\n  font-size: 10px;\n}\n\n.buy-credits-upsell__btn {\n  width: 100%;\n  padding: 7px 12px;\n  border: none;\n  border-radius: 6px;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  text-align: center;\n  background: var(--color-accent-base);\n  color: #fff;\n  transition: opacity 0.15s;\n}\n\n.buy-credits-upsell__btn:hover:not(:disabled) {\n  opacity: 0.88;\n}\n\n.buy-credits-upsell__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.buy-credits-upsell__btn--alt {\n  background: transparent;\n  border: 1px solid var(--color-border-input);\n  color: var(--color-text-primary);\n  font-weight: 500;\n}\n\n@media (max-width: 640px) {\n  .buy-credits-upsell__plans {\n    flex-direction: column;\n  }\n}\n\n.buy-credits-tiers {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n}\n\n.buy-credits-tier {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  padding: 14px 8px;\n  background: var(--color-bg-input);\n  border: 2px solid var(--color-border-input);\n  cursor: pointer;\n  font-family: inherit;\n  transition: border-color 0.1s;\n}\n\n.buy-credits-tier:hover {\n  border-color: var(--color-text-secondary);\n}\n\n.buy-credits-tier.selected {\n  border-color: var(--color-accent-base);\n  background: var(--color-bg-canvas-surface);\n}\n\n.buy-credits-tier-amount {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.buy-credits-tier-label {\n  font-size: 11px;\n  color: var(--color-text-secondary);\n}\n\n.buy-credits-custom {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.buy-credits-custom-label {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  font-weight: 500;\n}\n\n.buy-credits-custom-input-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.buy-credits-custom-input-row span {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.buy-credits-custom-input {\n  flex: 1;\n  padding: 8px 10px;\n  font-family: inherit;\n  font-size: 14px;\n  background: var(--color-bg-input);\n  border: 1px solid var(--color-border-input);\n  color: var(--color-text-primary);\n  outline: none;\n}\n\n.buy-credits-custom-input:focus {\n  border-color: var(--color-accent-base);\n}\n\n.buy-credits-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 4px;\n}\n\n.buy-credits-primary,\n.buy-credits-secondary {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1px solid var(--color-border-input);\n  font-family: inherit;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.buy-credits-primary {\n  background: var(--color-accent-base);\n  color: var(--color-text-on-accent);\n  font-weight: 600;\n}\n\n.buy-credits-primary:hover:not(:disabled) {\n  filter: brightness(0.96);\n}\n\n.buy-credits-primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.buy-credits-secondary {\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-weight: 500;\n}\n\n.buy-credits-secondary:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.buy-credits-error {\n  font-size: 13px;\n  color: var(--color-danger, #e55);\n  text-align: center;\n  margin: 0;\n}\n\n@media (max-width: 640px) {\n  .buy-credits-card {\n    padding: 22px 16px;\n  }\n\n  .buy-credits-tiers {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .buy-credits-header h2 {\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
